import React from 'react';
import { graphql } from 'gatsby';
import { NestedComponentRenderer } from '../../NestedComponentRenderer';

export const SharedNarrowContentPicker = ({
  data: { components },
  ...rest
}) => {
  const nestedComponents = components?.map((item) => {
    const { component } = item;

    return {
      ...component,
      areas: item.areas,
    };
  });

  return <NestedComponentRenderer components={nestedComponents} />;
};

export const SharedNarrowContentPickerQuery = graphql`
  fragment SharedNarrowContentPicker on UMBRACO_SharedNarrowContentPickerComponentType {
    components {
      remoteTypeName
      component {
        ...Accordion
        ...SharedNestedComponents
      }
      areas {
        blockGridItems {
          component {
            ...Accordion
            ...SharedNestedComponents
          }
        }
      }
    }
  }
`;
